export default {
  control: {
    backgroundColor: '#fff',
    fontSize: 15,
    fontWeight: '300'
  },
  '&multiLine': {
    width: '100%',
    control: {
      fontFamily: 'Lato',
      minHeight: 100
    },
    highlighter: {
      padding: 10,
      border: '1px solid transparent',
      backgroundColor: '#fcfcfc',
      minHeight: 100
    },
    input: {
      padding: 10,
      border: '1px solid #dddddd',
      borderRadius: 3,
      outlineColor: '#4a90e2'
    }
  },
  suggestions: {
    backgroundColor: 'none',
    list: {
      fontSize: 13,
      fontWeight: '500',
      backgroundColor: '#fff',
      padding: 5,
      border: '1px solid #dddddd',
      borderRadius: 3,
      maxHeight: 200,
      overflow: 'scroll',
      scrollSnapType: 'y mandatory',
      scrollPaddingBlockStart: 5,
      position: 'relative',
      top: 10,
      right: 12,
      width: '100%',
      boxShadow: '0 2px 7px 0 rgb(0 0 0 / 12%)'
    },
    item: {
      color: '#4a90e2',
      padding: '5px 15px',
      borderRadius: 3,
      scrollSnapAlign: 'start',
      '&focused': {
        color: '#fff',
        backgroundColor: '#4a90e2'
      }
    }
  }
};
